export default {
  setLanguage: (state, value) => {
    state.language = value
  },
  setSnackbar: (state, value) => {
    state.snackbar = value
  },
  setLoading: (state, value) => {
    state.loading = value
  },
  setError: (state, value) => {
    state.error = value
  },
  setSelectedLanguage: (state, value) => {
    state.selectedLanguage = value
  },
  setSearchString: (state, value) => {
    state.searchString = value
  },
  setSidebarDrawer: (state, value) => {
    state.sidebarDrawer = value
  },
  setCurrentPageNumber: (state, value) => {
    state.currentPageNumber = value
  },
  setAvailableApplications: (state, value) => {
    state.availableApplications = value
  },
  setAppIcons: (state, value) => {
    state.appIcons = value
  },
  setRefreshingApp: (state, value) => {
    state.refreshingApp = value
  },
  setSWRegistrationForNewContent: (state, value) => {
    state.SWRegistrationForNewContent = value
  },
  setVehicleNumberSearchString: (state, value) => {
    state.vehicleNumberSearchString = value
  },
  setQuickActions: (state, value) => {
    state.quickActions = value
  }
}
